import axios from 'axios'

// URL base dell'API per i voti delle proposte, recuperato dall'env file

const FIRME_REFERENDUM_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'voti-proposta'

const headers = { 'Content-Type': 'application/json' }

class VotiPropostaService {
    /**
     * Salva un voto di una proposta nel sistema.
     * Effettua una richiesta POST a `/voti-proposta/save` con i dati del voto.
     *
     * @param {Object} voto - Oggetto contenente i dettagli del voto da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    registraVoto(voto) {
        return axios.post(FIRME_REFERENDUM_REST_API_URL + "/save", voto, headers);
    }
    /**
     * Elimina un voto di una proposta nel sistema.
     * Effettua una richiesta POST a `/voti-proposta/delete` con i dati del voto.
     *
     * @param {Object} voto - Oggetto contenente i dettagli del voto da eliminare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    revocaVoto(voto) {
        return axios.post(FIRME_REFERENDUM_REST_API_URL + "/delete", voto, headers)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const votiPropostaServiceInstance = new VotiPropostaService()
export default votiPropostaServiceInstance